import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonBadge } from './Badge.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonBadge({ prefix }));
}
